export class AUDIODELAYDATA {

    ID: number;
    VQuad_Timestamp: Date;
    Call_Timestamp: Date;
    VQuad_Location: string;
    VQuad_PhoneID: string;
    GPS_Position: string;
    GPS_Lat: number;
    GPS_Long: number;

    RTD_Rating: string;
    PDD: number;
    SWR: number;
  CT: number;
  CCT: number;
    OWD: number;
  RTD: number;

  Signal_Level_Gain: number;
  Speech_Activity: number;
  Active_Speech_Level: number;
  Noise_Level_TDM: number;
  DC_Offset: number;
  Total_RMS_Power: number;
  Audio_BW: number;
  Audio_Power: number;
  Dropout: string;
    Line_Current: number;
    Line_Voltage: number;
    Ring_Type: string;
  Ring_Voltage: number;
  PTT_Setup_Time: number;
  PTT_Conn_Time: number;
    Double_Talk: string;
    Speech_Analysis: string;
    VMWI: string;
    SDT: number;

    RTD_Error: string;
    CallType_Orig: string;
    CallType_Term: string;
    VQuad_CallID: string;
 
    //AFT: string;
    //PDD_Error: string;
    //STT_Percent: string;
  constructor() {
    this.VQuad_Timestamp = new Date();
    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";

    this.GPS_Position = "";
    this.GPS_Lat = 0;
    this.GPS_Long = 0;

    this.RTD_Rating = "";
    this.PDD = 0;
    this.SWR = 0;
    this.CT = 0;
    this.CCT = 0;
    this.OWD = 0;
    this.RTD = 0;
    this.Signal_Level_Gain = 0;
    this.Speech_Activity = 0;
    this.Active_Speech_Level = 0;
    this.Noise_Level_TDM = 0;
    this.DC_Offset = 0;
    this.Total_RMS_Power = 0;
    this.Audio_BW = 0;
    this.Audio_Power = 0;
    this.Dropout = "";
    this.Line_Current = 0;
    this.Line_Voltage = 0;
    this.Ring_Type = "";
    this.Ring_Voltage = 0;
    this.PTT_Setup_Time = 0;
    this.PTT_Conn_Time = 0;
    this.Double_Talk = "";
    this.Speech_Analysis = "";
    this.VMWI = "";
    this.SDT = 0;
    this.RTD_Error = "";
    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";

    //this.AFT = "";
    //this.PDD_Error = "";
    //this.STT_Percent = "";
  }
}    

